import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { PayrollService } from "../payroll/payroll.service"
import { PayrollDelegate } from "../payroll/payroll.delegate"

export class PayrollServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): PayrollService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new PayrollDelegate(config, httpProvider);

        return new PayrollService(delegate, authenticationService);
    }
}